import { EditorFileSharingService } from '../Api/Api';
import { setAllFolders$ } from '../Observables/Folders.observable';
import { FileSharingService } from '../../Widget/Api/Api';

export const GetAllFolders = async (from = 'settings') => {
  const api =
    from === 'settings'
      ? new EditorFileSharingService()
      : new FileSharingService();
  const response = await api.getAllFolders();
  const tempResults = { ...response };
  if (tempResults?.data?.libraryItems) {
    const filterForFoldersOnly = tempResults?.data?.libraryItems.filter(
      (item: any) => {
        return Object.prototype.hasOwnProperty.call(item, 'folderFields');
      },
    );
    tempResults.data.libraryItems = filterForFoldersOnly;
    return tempResults;
  }
};

export const setAllFolders = (folders: []) => {
  setAllFolders$(folders);
};
